import React from "react";

const WebstaurantIcon = () => {
  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="32"
      viewBox="0 0 31 32"
      fill="none"
    >
      <g filter="url(#filter0_dd_3588_12990)">
        <path
          d="M0.00128174 5.6834V15.1065L2.03807 2.39893C0.830033 3.00672 0.00128174 4.24894 0.00128174 5.6834Z"
          fill="#198D00"
        />
        <path
          d="M16.3809 5.07891L20.8309 7.13451L17.6786 23.7668L27.9984 10.5269V5.68376C27.9984 3.64889 26.3335 2 24.2788 2H9.0745L5.54292 18.1621L16.3825 5.07891H16.3809Z"
          fill="#198D00"
        />
        <path
          d="M20.3414 29.7278H24.2791C26.3338 29.7278 27.9988 28.0789 27.9988 26.044V20.9968L20.3414 29.7263V29.7278Z"
          fill="#198D00"
        />
        <path
          d="M4.71548 26.8046L0.00128174 24.6278V26.0445C0.00128174 28.0794 1.66626 29.7282 3.72097 29.7282H11.571L14.6919 14.4209L4.71548 26.8046Z"
          fill="#198D00"
        />
        <path
          d="M28 10.5269L17.6801 23.7668L20.8324 7.13451L16.3825 5.07891L5.54299 18.1621L9.07449 2H3.71969C3.11343 2 2.54301 2.14493 2.0368 2.39928L0 15.1068V24.6275L4.71569 26.8043L14.6921 14.4207L11.5712 29.728H20.3411L27.9984 20.997V10.5269H28Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_3588_12990"
          x="-2.1"
          y="0.599999"
          width="32.2"
          height="31.9283"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.700001" />
          <feGaussianBlur stdDeviation="1.05" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3588_12990"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.700001" />
          <feGaussianBlur stdDeviation="0.700001" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_3588_12990"
            result="effect2_dropShadow_3588_12990"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_3588_12990"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default WebstaurantIcon;
